export enum EAssetType {
    Website = 1,
    Segment = 2,
    Company = 3,
}
